import React from "react";
import GeneralTab from "./GeneralTab";
import MembersTab from "./MembersTab";
import ChangePasswordPanel from "./ChangePasswordPanel";

/** Combined Workspace tab — identity + members + password in one scrollable surface,
 *  matching the user's request to collapse the prior 6-tab settings shell. */
export default function WorkspaceTab({ isOwner }) {
  return (
    <div className="space-y-8" data-testid="workspace-tab">
      <GeneralTab isOwner={isOwner} />
      <div className="border-t border-zinc-900" />
      <div>
        <h2 className="font-heading font-black text-xl tracking-tight mb-1">Team & invites</h2>
        <p className="font-mono text-[11px] text-zinc-500 mb-4">
          Invite analysts and executives. Owner controls roles and revocation.
        </p>
        <MembersTab isOwner={isOwner} />
      </div>
      <div className="border-t border-zinc-900" />
      <div>
        <h2 className="font-heading font-black text-xl tracking-tight mb-1">Account security</h2>
        <p className="font-mono text-[11px] text-zinc-500 mb-4">
          Change the password for your personal DARA login.
        </p>
        <ChangePasswordPanel />
      </div>
    </div>
  );
}
